module.exports = __webpack_public_path__ + "static/media/mobile.f24bdca1.png";